export const fieldNames = {
  NAME: 'inputName',
  LAST_NAME: 'inputLastName',
  EMAIL: 'inputEmail',
  PASSWORD: 'inputPassword',
  CONFIRM_PASSWORD: 'inputConfirmPassword',
  NEW_PASSWORD: 'inputNewPassword',
  PHONE: 'inputPhone',
  IMAGE: 'image',
  PROJECT_NAME: 'projectName',
  PROJECT_WEBSITE: 'projectWebsite',
  PROJECT_ACTIVITY_FIELD: 'projectActivityField',
  PROJECT_IMAGE: 'projectImage',
  COMPANY_SIZE: 'company_size',
  PROMOTION_CHANNELS_PLATFORMS: 'platforms',
  PROMOTION_CHANNELS_SOCIAL_MEDIA: 'socialMedia',
  PROMOTION_CHANNELS_OFFLINE_EVENTS: 'offlineEvents',
  PROBLEMS_LIST: 'problemsList',
  PROBLEMS_GOAL: 'problemsGoal',
  PROBLEMS_PRIORITY: 'problemsProirity',
  APPEAL_TITLE: 'appealTitle',
  APPEAL_DESCRIPTION: 'appealDescription',
  APPEAL_IMAGES: 'appealImages',
  HYPOTHESES_FILTER_STATUS: 'statusId',
  HYPOTHESES_FILTER_TOOL: 'toolId',
  HYPOTHESES_FILTER_PRIORITY: 'priorityId',
  HYPOTHESES_FILTER_PROCESS_STATUS: 'processStatus',
  HYPOTHESES_FILTER_ACHIVEMENT_STATUS: 'achivenmentStatus',
  HYPOTHESES_FILTER_GROWTH_POINT: 'growthPointId',
  HYPOTHESES_FILTER_MARK: 'markId',
  HYPOTHESES_FILTER_MARK_TYPE: 'markTypeId',
  HYPOTHESES_FILTER_KIND: 'kindId',
} as const
